import { Component, Input, OnInit } from '@angular/core';
import { SliderOptions, SliderType } from '../../models/sections-model';
import { animate, group, keyframes, query, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'kw-slider-renderer',
  templateUrl: './slider-renderer.component.html',
  styleUrls: ['./slider-renderer.component.scss'],
  /* animations:[
    trigger('sliderAnimation',[
      transition(":increment",group([
        query(':enter',[
          style({transform: 'translateX(100%)', height:'330px'}),
          animate('0.5s linear', keyframes(
            [
              style({ transform: 'translateX(100%)',height:'330px' }),
              style({ transform: 'translateX(0)',height:'330px'})
            ]))          
        ]),
        query(':leave', [
          animate('0.5s ease-out', style({ left: '-100%',height:'330px' }))
        ])
      ])),
      transition(":decrement", group([
        query(':enter', [
          style({ transform: 'translateX(-100%)',height:'330px' }),
          animate('0.5s linear', keyframes([
            style({ transform: 'translateX(-100%)',height:'330px' }),
            style({ transform: 'translateX(0)',height:'330px'})
          ]))
        ]),
        query(':leave', [
          animate('0.5s linear', style({ transform: 'translateX(100%)',height:'330px' }))
        ])
      ])),
    ])
  ] */
})
export class SliderRendererComponent implements OnInit {
  @Input() data:SliderOptions;
  @Input() edit:boolean;
  slides:any[];
  layout:string;

  actualIndex = 0;
  selectedIndex = 0;

  itemsLength:number;

  autoStart = false;

  sliderType:SliderType;

  constructor() { }

  ngOnInit(): void {
    console.log(this.data);
    /* this.slides = this.data.slides;
    this.itemsLength = this.slides.length; */
    this.sliderType = this.data.sliderType?this.data.sliderType:SliderType.ROW;
    this.layout = this.data.layout;
  }

  /* get items() {
    return [this.slides[this.actualIndex]];
  } */

}
